module.exports = {
    machineUnder: {
        texture: '/img/partials/slotmachine/machine-under.png'
    },

    machineOver: {
        texture: '/img/partials/slotmachine/machine-over.png'
    },

    singleResultWin: {
        texture: '/img/partials/slotmachine/single-result-win.png'
    },

    singleResultLose: {
        texture: '/img/partials/slotmachine/single-result-lose.png'
    },

    charles: {
        type: 'movieclip',
        /* texture: [
            '/img/partials/slotmachine/charles/charles-crank-0.png',// 0
            '/img/partials/slotmachine/charles/charles-crank-1.png',
            '/img/partials/slotmachine/charles/charles-crank-2.png',
            '/img/partials/slotmachine/charles/charles-crank-3.png',
            '/img/partials/slotmachine/charles/charles-crank-4.png',
            '/img/partials/slotmachine/charles/charles-crank-5.png',
            '/img/partials/slotmachine/charles/charles-idle.png',// 6
            '/img/partials/slotmachine/charles/charles-win-0.png',// 7
            '/img/partials/slotmachine/charles/charles-win-1.png',
            '/img/partials/slotmachine/charles/charles-win-2.png',
            '/img/partials/slotmachine/charles/charles-win-3.png',
            '/img/partials/slotmachine/charles/charles-win-4.png',
            '/img/partials/slotmachine/charles/charles-win-5.png',
            '/img/partials/slotmachine/charles/charles-win-6.png',
            '/img/partials/slotmachine/charles/charles-lose-0.png',// 14
            '/img/partials/slotmachine/charles/charles-lose-1.png',
            '/img/partials/slotmachine/charles/charles-lose-2.png',
            '/img/partials/slotmachine/charles/charles-lose-3.png',
            '/img/partials/slotmachine/charles/charles-lose-4.png',
            '/img/partials/slotmachine/charles/charles-lose-5.png',
            '/img/partials/slotmachine/charles/charles-lose-6.png',
            '/img/partials/slotmachine/charles/charles-lose-7.png',
            '/img/partials/slotmachine/charles/charles-lose-8.png',
            '/img/partials/slotmachine/charles/charles-lose-9.png'// 23
        ] */
        texture: 'sprite:/img/partials/slotmachine/charles.json'
    },

    slotMachinePipe: {
        texture: '/img/partials/slotmachine/slotmachine-pipe.png',
        scale: {
            x: '80%'
        },
        position: {
            x: '0%',
            y: '49.9%'
        }
    },

    plateau: {
        texture: '/img/partials/slotmachine/plateau.png',
        scale: {
            x: '100%'
        },
        position: {
            x: '0%',
            y: '49%'
        }
    },

    bigSlotMachineBg: {
        texture: '/img/partials/slotmachine/big-slotmachine-bg.jpg',
        scale: {
            x: '100%'
        }
    },

    smallSlotMachineBg: {
        texture: '/img/partials/slotmachine/small-slotmachine-bg.jpg',
        scale: {
            x: '100%'
        }
    }
};



// WEBPACK FOOTER //
// ./js/objects/partials/slotMachine.js